module.exports = __webpack_public_path__ + "img/stackslash-24-mobile.3de571c6.jpg";